import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ListComponent {
    @Input() class: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/list/list.component.ts